import * as z from "zod";
import { RoutingRuleConfigSchema } from "./routing-rule-config";

/**
 * Per-integration configuration for Redo-managed returns with refulfillment,
 * applied only for merchants on managed returns. Only the rule-type pipeline
 * ({@link RoutingRuleConfigSchema}) is shared across providers.
 */
const ShopifyManagedReturnsSchema_ = z.object({
  enabled: z.boolean().default(false),
  order: z
    .object({
      routingRules: z.array(RoutingRuleConfigSchema).nullish(),
      defaultFulfillmentLocation: z
        .object({
          externalLocationId: z.string().nullish(),
          teamId: z.string().nullish(),
        })
        .nullish(),
      allowSplitShipments: z.boolean().nullish(),
      fulfillmentTags: z.array(z.string()).nullish(),
    })
    .nullish(),
});
export const ShopifyManagedReturnsSchema: z.ZodType<ShopifyManagedReturns> =
  ShopifyManagedReturnsSchema_;

export interface ShopifyManagedReturns extends z.infer<
  typeof ShopifyManagedReturnsSchema_
> {}
